module.exports = __webpack_public_path__ + "static/img/classroom_2.15f1a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/classroom_2.jpg
// module id = rVl7
// module chunks = 3